import React, { useState, Fragment } from 'react';
import H3FormInput from '@Uilib/h3FormInput';
import { PropTypes } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import {
  Button,
  Divider, Drawer, Popover, Select, Table, Dropdown, Menu,
} from 'antd';
import './style.scss';
import dayjs from 'dayjs';
import closeIcon from '@Images/icons/icon-close-blue.png';
import H3Image from '@Uilib/h3Image';
import Helpers from '@Apis/helpers';
import {
  LoadingOutlined, UserOutlined,
} from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import AnalyticsActions from '@Actions/application/analyticsActions';
import Constants from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import TransporterDrawer from '../TransporterDrawer';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;

const ViewEwayBill = ({
  selectedEwaybill, cancelEwaybillLoading, cancelEwaybill, user, callback, fetchEwayBill, fetchEwayBillLoading, MONEY, downloadDocument, priceMasking, isQuickView,
}) => {
  const [showTransportDrawer, setShowTransportDrawer] = useState(false);
  const [cancellationRemark, setCancellationRemark] = useState('');
  const [cancellationReason, setCancellationReason] = useState('');

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const partBcolumns = [{
    title: 'Mode Of Transportation',
    render: (record) => (
      <div>
        <H3Text text={record?.transportation_mode} />
      </div>
    ),
  },
  {
    title: 'Vehicle No / Trans Doc No',
    render: (record) => (
      <div>
        <H3Text text={record?.vehicle_number || record?.transportation_doc_number} />
      </div>
    ),
  },
  {
    title: 'Trans Doc Date',
    render: (record) => (
      <div>
        <H3Text text={record?.transportation_doc_date ? dayjs(record?.transportation_doc_date).format('DD-MM-YYYY') : '-'} />
      </div>
    ),
  },
  {
    title: 'Updated Time',
    render: (record) => (
      <div>
        <H3Text
          text={dayjs(record?.modified_at)?.format('DD/MM/YYYY h:mm A')}
        />

      </div>
    ),
  },
  ];

  const cancellationReasonOptions = [
    { label: 'Duplicate', value: 'DUPLICATE' },
    { label: 'Order Cancelled', value: 'ORDER CANCELLED' },
    { label: 'Data Entry Mistake', value: 'DATA ENTRY MISTAKE' },
    { label: 'Others', value: 'OTHERS' },
  ];

  return (
    <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ''}`}>
      <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
        <div className="view-document__title">
          <div className="view-document__title-number-wrapper">
            <H3Text text={`EWB# ${selectedEwaybill?.ewb_no}`} className="view-document__title-number" />
            <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedEwaybill?.status).color }}>
              {selectedEwaybill?.status?.replaceAll('_', ' ')}
            </div>
          </div>
          <div className="view-document__title-actions">
            <div className="action-buttons">
              <Dropdown
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                overlay={(
                  <Menu style={{ width: '185px' }}>
                    <Menu.Item>
                      <H3Text
                        text="e-way bill"
                        onClick={() => downloadDocument({
                          url: `${Constants.DOWNLOAD_E_WAY_BILL}?type=pdf&ewb_number=${selectedEwaybill?.ewb_no}&tenant_id=${user?.tenant_info?.tenant_id}`,
                          document_type: 'EWayBill',
                          document_number: selectedEwaybill?.ewb_no,
                          key: uuidv4(),
                        })}
                        className="hide__in-mobile"
                        style={{ padding: '5px 12px', fontSize: '14px' }}
                      />
                    </Menu.Item>
                    <Menu.Item>
                      <H3Text
                        text="detailed e-way Bill"
                        onClick={() => downloadDocument({
                          url: `${Constants.DOWNLOAD_E_WAY_BILL}?type=detailed_pdf&ewb_number=${selectedEwaybill?.ewb_no}&tenant_id=${user?.tenant_info?.tenant_id}`,
                          document_type: 'EWayBill',
                          document_number: selectedEwaybill?.ewb_no,
                          key: uuidv4(),
                        })}
                        className="hide__in-mobile"
                        style={{ padding: '5px 12px', fontSize: '14px' }}
                      />
                    </Menu.Item>
                  </Menu>
                )}
                trigger={['click']}
                placement="topLeft"
              >
                <div className="action-button" onClick={(e) => e.preventDefault()}>
                  <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
                </div>
              </Dropdown>
              {Helpers.getPermission(Helpers.permissionEntities.E_WAY_BILL, Helpers.permissionTypes.UPDATE, user) && (
                <Popover
                  placement="topRight"
                  trigger="click"
                  title={<div style={{ width: '280px' }}>Are you sure to cancel this e-Way Bill?</div>}
                  content={(
                    <React.Fragment>
                      <div className="orgFormContainer" style={{ marginBottom: '10px' }}>
                        <label className="orgFormLabel">
                          Reason for cancellation
                          <span style={{ color: 'red' }}> *</span>
                        </label>
                        <PRZSelect
                          placeholder="Select a Reason"
                          onChange={(value) => setCancellationReason(value)}
                          dropdownStyle={{ zIndex: 9999 }}
                          value={cancellationReason}
                          disabled={cancelEwaybillLoading}
                          options={cancellationReasonOptions}
                        />
                      </div>
                      <H3FormInput
                        name="cancellation remark"
                        type="text"
                        label="Remarks"
                        labelClassName="orgFormLabel"
                        containerClassName="orgInputContainer"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => setCancellationRemark(event.target.value)}
                        value={cancellationRemark}
                        maxlength="50"
                        required
                        disabled={cancelEwaybillLoading}
                      />
                      <div className="IRN__cancellation-buttons">
                        <Button
                          onClick={() => {
                            if (cancellationRemark || cancellationReason) {
                              cancelEwaybill({
                                ewb_id: selectedEwaybill?.ewb_id,
                                ewb_no: selectedEwaybill?.ewb_no,
                                cancel_reason: cancellationReason,
                                cancel_remark: cancellationRemark,
                                tenant_id: user?.tenant_info?.tenant_id,
                              }, () => {
                                setCancellationReason('');
                                setCancellationRemark('');
                                callback();
                              });
                            }
                          }}
                          type="primary"
                          size="small"
                          loading={cancelEwaybillLoading}
                        >
                          Confirm
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                >
                  <H3Text
                    className="action-button action-button-big"
                    onClick={() => {}}
                    text="Cancel"
                  />
                </Popover>
              )}
              <H3Text
                className="action-button action-button-big"
                onClick={() => {
                  fetchEwayBill({
                    tenant_id: selectedEwaybill?.tenant_id,
                    document_id: selectedEwaybill?.document_id,
                    doc_type: selectedEwaybill?.doc_type,
                    ewb_no: selectedEwaybill?.ewb_no,
                  }, () => callback());
                }}
                text={(
                  <Fragment>
                    {fetchEwayBillLoading ? <LoadingOutlined /> : 'Refresh'}
                  </Fragment>
                )}
              />
            </div>
          </div>
        </div>
        <div className="document-header">
          <div className="ant-row">
            {selectedEwaybill?.customer_info && (
              <div className="ant-col-md-24">
                <H3Text
                  text={(
                    <span>
                      <UserOutlined />
                      {' '}
                      <span>{`${selectedEwaybill?.customer_info?.customer_name} (${selectedEwaybill?.customer_info?.gst_number}) `}</span>
                    </span>
                  )}
                  className="document-header__party-name"
                />
              </div>
            )}
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="EWB Date" className="document-header__field-name" />
                <H3Text
                  text={dayjs(selectedEwaybill?.created_at)?.format('DD/MM/YYYY h:mm A')}
                  className="document-header__field-value"
                />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Validity" className="document-header__field-name" />
                <H3Text text={['1970-01-01T00:00:00', null].includes(selectedEwaybill?.expires_at) ? 'Not Available' : `${dayjs(selectedEwaybill?.expires_at).diff(dayjs(selectedEwaybill?.created_at), 'day')} Days`} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Valid From" className="document-header__field-name" />
                <H3Text text={dayjs(selectedEwaybill?.created_at)?.format('DD/MM/YYYY h:mm A')} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Expires On" className="document-header__field-name" />
                <H3Text text={['1970-01-01T00:00:00', null].includes(selectedEwaybill?.expires_at) ? 'Not Available' : dayjs(selectedEwaybill?.expires_at)?.format('DD/MM/YYYY h:mm A')} className="document-header__field-value" />
              </div>
            </div>
          </div>
        </div>
        <Divider orientationMargin="0" orientation="left">Part A</Divider>
        <div className="document-header">
          <div className="ant-row">
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="GSTIN of Supplier" className="document-header__field-name" />
                <H3Text text={selectedEwaybill?.supplier_gst_number} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Place of Dispatch" className="document-header__field-name" />
                <H3Text text={selectedEwaybill?.ship_from?.state.toProperCase()} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Place of Delivery" className="document-header__field-name" />
                <H3Text text={selectedEwaybill?.ship_to?.state.toProperCase()} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Document No" className="document-header__field-name" />
                <H3Text
                  text={(
                    <Link
                      to={
                        selectedEwaybill?.doc_type === 'INV' ? `/sales/invoice/view/${selectedEwaybill?.document_id}`
                          : (selectedEwaybill?.doc_type === 'CNT' ? `/sales/credit-note/view/${selectedEwaybill?.document_id}` : `/inventory/delivery-challan/view/${selectedEwaybill?.document_id}`)
                      }
                      target="_blank"
                    >
                      {selectedEwaybill?.document_number}
                      {` (${dayjs(selectedEwaybill?.document_date).format('DD/MM/YYYY')})`}
                    </Link>
                  )}
                  className="document-header__field-value"
                />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Amount" className="document-header__field-name" />
                <H3Text
                  text={MONEY(selectedEwaybill?.document_total)}
                  className="document-header__field-value"
                  hideText={isDataMaskingPolicyEnable && isHideSellingPrice}
                  popOverMessage={"You don't have access to view amount"}
                />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Transporter" className="document-header__field-name" />
                <H3Text text={selectedEwaybill?.transporter_info?.seller_name} className="document-header__field-value" />
              </div>
            </div>
            <div className="ant-col-md-24">
              <div className="document-header__field">
                <H3Text text="Distance (in KM)" className="document-header__field-name" />
                <H3Text text={selectedEwaybill?.distance} className="document-header__field-value" />
              </div>
            </div>
          </div>
        </div>
        <Divider orientationMargin="0" orientation="left">Part B</Divider>
        <Table
          columns={partBcolumns || []}
          dataSource={selectedEwaybill?.vehicle_details}
          pagination={false}
          size="small"
        />
        <H3Text text="+ Vehicle Details" onClick={() => setShowTransportDrawer(true)} className="add-transport" />
      </div>
      <Drawer
        open={showTransportDrawer}
        width="520px"
        mask
        onClose={() => setShowTransportDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '475px' }}>
            <H3Text text="Update Transport Details" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowTransportDrawer(false)} />
          </div>
        </div>
        <TransporterDrawer drawermode selectedEwaybill={selectedEwaybill} callback={callback} />
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({ EinvoiceEwaybillReducers, UserReducers }) => ({
  MONEY: UserReducers.MONEY,
  user: UserReducers.user,
  cancelEwaybillLoading: EinvoiceEwaybillReducers.cancelEwaybillLoading,
  fetchEwayBillLoading: EinvoiceEwaybillReducers.fetchEwayBillLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  cancelEwaybill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.cancelEwaybill(payload, callback)),
  fetchEwayBill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.fetchEwayBill(payload, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),

});

ViewEwayBill.propTypes = {
  history: PropTypes.func,
  selectedEwaybill: PropTypes.any,
  cancelEwaybill: PropTypes.func,
  cancelEwaybillLoading: PropTypes.bool,
  user: PropTypes.any,
  callback: PropTypes.func,
  fetchEwayBillLoading: PropTypes.bool,
  fetchEwayBill: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewEwayBill));
